import React, { FC, useEffect } from 'react';
import classNames from 'classnames';

let activeScrollLocks = 0;

const lockBodyScroll = () => {
  activeScrollLocks += 1;
  document.body.classList.add('hidden_scroll');
};

const unlockBodyScroll = () => {
  activeScrollLocks = Math.max(0, activeScrollLocks - 1);
  if (activeScrollLocks === 0) {
    document.body.classList.remove('hidden_scroll');
  }
};

const ModalWrap: FC<{ isShow: boolean; children: React.ReactNode; className?: string }> = ({
  isShow = false,
  children,
  className,
}) => {
  useEffect(() => {
    if (!isShow) {
      return;
    }

    lockBodyScroll();
    return unlockBodyScroll;
  }, [isShow]);

  if (!isShow) {
    return null;
  }

  return (
    <div
      className={classNames(
        'w-full h-full fixed bottom-0 top-0 right-0 left-0 z-[1000] bg-blackBaseOpacity20 backdrop-blur-[1px] flex items-center justify-center p-[15px]',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ModalWrap;
